module.exports = __webpack_public_path__ + "static/media/DSC04738.c9ae27c8.JPG";